import { Env } from '../../../core/env';
import { SearchwordSuggestionAction } from "../actions/searchword_suggestion_action";
import { SearchTotalItemAction } from '../actions/search_total_item_action';

document.addEventListener('DOMContentLoaded', () => {
  SearchwordSuggestionAction.init(Env);
  SearchTotalItemAction.init(Env);
});
